"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HhnException = void 0;
const ErrorMessages_1 = require("./ErrorMessages");
class HhnException extends Error {
    constructor(e) {
        super(e);
        this.stack = e.stack;
        this.name = "HHNException";
    }
}
exports.HhnException = HhnException;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function handleError(e) {
    var _a;
    const errorResponse = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data;
    if (errorResponse &&
        errorResponse.statusCode === 400 &&
        !errorResponse.responseType) {
        switch (errorResponse.responseType) {
            case ErrorMessages_1.ErrorCodes.GROUP_ALREADY_EXIST_WITH_SAME_DOB:
            case ErrorMessages_1.ErrorCodes.GROUP_ALREADY_EXIST:
                return errorResponse.message;
            default:
                return ErrorMessages_1.ErrorMessages.genericError;
        }
    }
    else {
        return ErrorMessages_1.ErrorMessages.genericError;
    }
}
